import '@/assets/styles/main.scss'

import { createApp } from 'vue'

import * as Sentry from '@sentry/vue'

import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'

const app = createApp(App)

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  release: __APP_VERSION__,

  // Disable PII collection (IP addresses, user data) for privacy compliance
  sendDefaultPii: false,

  // Performance monitoring sample rate (10% of transactions)
  tracesSampleRate: 0.1,

  // Only enable in production
  enabled: import.meta.env.PROD,

  beforeSend(event) {
    const msg = event.exception?.values?.[0]?.value ?? event.message ?? ''

    // Ignore errors injected by browser extensions — these are not application bugs.
    // Patterns cover: MetaMask/Web3, Dark Reader, Chrome extension messaging, and
    // other extension globals that bleed into the page's error boundary.
    const extensionPatterns = [
      /window\.ethereum/i,
      /DarkReader/i,
      /runtime\.sendMessage/i,
      /chrome-extension:\/\//i,
      /moz-extension:\/\//i,
      /safari-extension:\/\//i,
    ]
    if (extensionPatterns.some((re) => re.test(msg))) return null

    // Ignore errors originating from extension script URLs in the stack frames
    const frames = event.exception?.values?.flatMap((v) => v.stacktrace?.frames ?? []) ?? []
    const extensionUrlPatterns = [/chrome-extension:\/\//, /moz-extension:\/\//, /safari-extension:\/\//]
    if (frames.some((f) => extensionUrlPatterns.some((re) => re.test(f.filename ?? '')))) return null

    return event
  },
})

app.use(router)
app.use(vuetify)

app.mount('#app')
